import LandingPageShell from "@/components/landing-page/layout/LandingPageShell";
import PageHero from "@/components/landing-page/PageHero";
import Faq from "@/components/landing-page/home/Faq";
import FinalCta from "@/components/landing-page/home/FinalCta";

export default function FaqsPage() {
  return (
    <LandingPageShell>
      <PageHero
        eyebrow="FAQs"
        title="Questions from HR and L&D teams."
        description="How inaraX works, who it is for, and what it takes to roll it out across your organization."
      />
      <Faq heading="Frequently asked questions" />
      <FinalCta />
    </LandingPageShell>
  );
}
